<div class="input-grid-gaps grid-6col container">
    <div class="fr-6 flex gap align-items-center">
        <p-fileUpload #fu mode="basic" name="myFile[]" auto="false" [customUpload]="true"
            [chooseLabel]="'common.selectFile' | translate"
            chooseIcon="pi pi-upload" accept=".csv"
            (onSelect)="onFileSelect($event)" (onClear)="onFileClear()"
        >
        </p-fileUpload>
        @if (fu.files.length) {
            <app-button icon="pi pi-times" (clickEvent)="fu.clear()"></app-button>
        }
    </div>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonDisability]="!isValid"
        [primaryButtonLoading]="processing"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    >
    </app-action-buttons>
</div>
